export const isDev = () => {
  return import.meta.env.MODE === "development";
};

export const afterAuthRedirect = "/account/dashboard?authorized"

export const isAdmin = (userID) => {
  return (
    userID === "64f1e6e336c4dcee91de5a5c" ||
    userID === "64ad7387327ef6ea9b0eb75f"
  );
};

const pricingMap = [
  {
    name: "hobby",
    productID: 838915,
    yearly: false,
  },
  {
    name: "advanced",
    productID: 838916,
    yearly: false,
  },
  {
    name: "professional",
    productID: 838923,
    yearly: false,
  },
  {
    name: "premium",
    productID: 838924,
    yearly: false,
  },
  // YEARLY PLANS
  {
    name: "hobby",
    productID: 838926,
    yearly: true,
  },
  {
    name: "advanced",
    productID: 838927,
    yearly: true,
  },
  {
    name: "professional",
    productID: 838928,
    yearly: true,
  },
  {
    name: "premium",
    productID: 838929,
    yearly: true,
  },
  // LTD OFFERS
  {
    name: "professional-ltd",
    productID: 851730,
    yearly: false,
  },
];

let domain = !isDev() ? window.location.hostname : "dev.multiagent.ai";

export const API_VERSION = "/api/v1";

const prod = {
  baseURL: "",
  url: {
    DOMAIN: `https://${domain}`,
    API_PREFIX: `https://${domain}${API_VERSION}/`,

    SIGN_IN_URL: `https://${domain}${API_VERSION}/auth/google?source=site`,
    SIGN_OUT_URL: `https://${domain}${API_VERSION}/auth/logout/google`,
    SETTINGS_URL: `https://${domain}${API_VERSION}/admin/settings`,
    MAIN_SITE_URL: `https://${domain}`,

    CHATBOT_CREATE: `https://${domain}${API_VERSION}/chatbot/create`,
  },
  paddle: {
    vendorID: 38729,
    sourceName: "wizychat",
  },
  pricing: pricingMap,
};

const dev = {
  baseURL: "",
  url: {
    DOMAIN: `https://${domain}`,
    API_PREFIX: `https://${domain}${API_VERSION}/`,

    SIGN_IN_URL: `https://${domain}${API_VERSION}/auth/google?source=site`,
    SIGN_OUT_URL: `https://${domain}${API_VERSION}/auth/logout/google`,
    SETTINGS_URL: `https://${domain}${API_VERSION}/admin/settings`,
    MAIN_SITE_URL: `https://${domain}`,

    CHATBOT_CREATE: `https://${domain}${API_VERSION}/chatbot/create`,
  },
  paddle: {
    vendorID: 38729,
    sourceName: "wizychat-dev",
  },
  pricing: pricingMap,
};

export const constants = !isDev() ? prod : dev;
